import React from 'react'

function Subjects(props) {

    let arr =
        [
            // Computer Science
            {
                branch: "Computer Science",
                sem: "1",
                sub: ["Communication Skill-I",
                    "Applied mathematics-I",
                    "Applied physics-I",
                    "Applied chemistry",
                    "Workshop",
                    "FCIT",
                    "Technical Drawing",],
            },
            {
                branch: "Computer Science",
                sem: "2",
                sub: ["Applied mathematics-II",
                    "Applied physics-II",
                    "BEE",
                    "Multimedia & Animation",
                    "Office automation tools",
                    "Concept of programming using c"],
            }, {
                branch: "Computer Science",
                sem: "3",
                sub: ["Applied mathematics-III",
                    "Internet & Web Technology",
                    "Data Structure using c",
                    "Digital electronics",
                    "Environmental studies",
                    "Data Communication and Computer Networks"],
            }, {
                branch: "Computer Science",
                sem: "4",
                sub: ["Communication Skill-II",
                    "DBMS",
                    "Operating System",
                    "E-commerce & Digital marketing",
                    "UHV",
                    "OOP using Java"],
            }, {
                branch: "Computer Science",
                sem: "5",
                sub: ["Industrial Training",
                    "Web devlopment using php",
                    "CP using python",
                    "CA & HM ",
                    "IOT",
                    "Minor project work"],
            }, {
                branch: "Computer Science",
                sem: "6",
                sub: ["Devlopment of android application",
                    "Cloud computing",
                    "IMED",
                    "Elective",
                    "Major project work"],
            },

            // information and technology
            {
                branch: "Information Technology",
                sem: "1",
                sub: [
                    "Communication Skill-I",
                    "Applied mathematics-I",
                    "Applied physics-I",
                    "Applied chemistry",
                    "Workshop",
                    "FCIT",
                    "Technical Drawing",
                ],
            },
            {
                branch: "Information Technology",
                sem: "2",
                sub: [
                    "Applied mathematics-II",
                    "Applied physics-II",
                    "BEE",
                    "Multimedia & Animation",
                    "Office automation tools",
                    "Concept of programming using c"
                ],
            },
            {
                branch: "Information Technology",
                sem: "3",
                sub: [
                    "Applied mathematics-III",

                    "IWT",
                    "Ds using c",
                    "Digital electronics",
                    "Environmental studies",
                    "DCCN",
                ],
            },
            {
                branch: "Information Technology",
                sem: "4",
                sub: [
                    "Communication Skill-II",
                    "DBMS",
                    "Operating System",
                    "E-commerce & Digital marketing",
                    "UHV",
                    "OOP using java",
                    "EC",
                ],
            },
            {
                branch: "Information Technology",
                sem: "5",
                sub: [
                    "Industrial Training",
                    "Web devlopment using php",
                    "CP using python",
                    "CA & HM ",
                    "IOT",
                    "Minor project work",
                    "SE",
                ],
            },
            {
                branch: "Information Technology",
                sem: "6",
                sub: [
                    "Devlopment of android application",
                    "Cloud computing",
                    "IMED",
                    "Elective",
                    "Major project work",
                ],
            },


            //Electronics engineering
            {
                branch: "Electronics",
                sem: "1",
                sub: [
                    "Communication Skill-I",
                    "Applied mathematics-I",
                    "Applied physics-I",
                    "Applied chemistry",
                    "Workshop",
                    "Basics of Information Technology",
                    "Engineering Drawing-I"
                ],
            },
            {
                branch: "Electronics",
                sem: "2",
                sub: [
                    "Applied mathematics-II",
                    "Applied physics-II",
                    "Basic Electrical Engineering",
                    "Electrical and Electronics Workshop ",
                    "Electronics Component and Device",
                    "Workshop-II"
                ],
            },
            {
                branch: "Electronics",
                sem: "3",
                sub: [
                    "Applied mathematics-III",

                    "Electrical and Electronics Instrumentation and Measurement ",
                    "Electrical and Electronics Engineering Materials ",
                    "Digital electronics",
                    "Electrical Machine - I ",
                    "Environmental Studies",
                ],
            },
            {
                branch: "Electronics",
                sem: "4",
                sub: [
                    "Communication Skill-II",
                    "Industrial Electronics and Control ",
                    "Electrical Design, Drawing and Estimating-I ",
                    "Network Filters and Transmission Lines ",
                    "Transmission and Distribution of Electrical Power ",
                    "Principles of Communication Engineering",
                    "Energy Conservation",
                ],
            },
            {
                branch: "Electronics",
                sem: "5",
                sub: [
                    "Industrial Management and Entrepreneurship Development ",
                    "Switchgear and Protection ",
                    "Microprocessor And Peripheral devices ",
                    "Electrical Machine -II  ",
                    "Elective",
                ],
            },
            {
                branch: "Electronics",
                sem: "6",
                sub: [
                    "Installation, Maintenance and Repair of Electrical Equipment",
                    "Electrical Design, Drawing and Estimating II",
                    "Control System",
                    "Application of Computer Software in Electrical Engineering",
                    "Universal Human Values ",
                    "Project Work ",
                    "Evaluation Strategy ",
                ],
            },
            //Mechanicalineering
            {
                branch: "Mechanical",
                sem: "1",
                sub: [
                    "Communication Skill-I",
                    "Applied mathematics-I",
                    "Applied physics-I",
                    "Applied chemistry",
                    "Workshop",
                    "Basics of Information Technology",
                    "Engineering Drawing-I"
                ],
            },
            {
                branch: "Mechanical",
                sem: "2",
                sub: [
                    "Applied mathematics-II",
                    "Applied physics-II",
                    "Applied Mechanics ",
                    "General Engineering",
                    "Engineering Drawing -II ",
                    " Workshop-II"
                ],
            },
            {
                branch: "Mechanical",
                sem: "3",
                sub: [
                    "Applied mathematics-III",

                    "Engineering Materials  ",
                    "Mechanics of Solids  ",
                    "Thermal Engineering",
                    "Computer Aided Drafting and 3D Modelling ",
                    "Workshop Technology",
                ],
            },
            {
                branch: "Mechanical",
                sem: "4",
                sub: [
                    "Communication Skill-II",
                    "Refrigeration and Air Conditioning ",
                    "Hydraulics and Pneumatics ",
                    "Computer Aided Design and Manufacturing  ",
                    "Environmental Studies ",
                    "Energy Conservation",
                    "Universal Human Values",
                ],
            },
            {
                branch: "Mechanical",
                sem: "5",
                sub: [
                    "Industrial Training  ",
                    "Industrial Management and Entrepreneurship Development ",
                    "Theory of Machines  ",
                    "Machine Design   ",
                    "Production Technology ",
                    "Production Management  ",
                    "Automobile Engineering  ",
                ],
            },
            {
                branch: "Mechanical",
                sem: "6",
                sub: [
                    "Industrial Engineering ",
                    "Metrology and Measuring Instruments ",
                    "CNC Machines and Automation",
                    "Elective",
                    "Project Work  ",
                ],
            },
            //Instrumentaion Controlineering
            {
                branch: "Instrumental and control Eng",
                sem: "1",
                sub: [
                    "Communication Skill-I",
                    "Applied mathematics-I",
                    "Applied physics-I",
                    "Applied chemistry",
                    "Workshop-I",
                    "Engineering Mechanics and Materials  ",
                    "Engineering Drawing-I"
                ],
            },
            {
                branch: "Instrumental and control Eng",
                sem: "2",
                sub: [
                    "Applied mathematics-II",
                    "Applied physics-II",
                    "Basics of Information Technology",
                    "Electrical Engineering-I ",
                    "Electronic Components and Devices ",
                    "Workshop-II"
                ],
            },
            {
                branch: "Instrumental and control Eng",
                sem: "3",
                sub: [
                    "Applied mathematics-III",
                    "Universal Human Values",
                    "Electrical Engineering-II  ",
                    "Electronic Devices and Circuits  ",
                    "Electronics Workshop",
                    "TRANSDUCER & APPLICATION  ",
                    "Environmental Studies",

                ],
            },
            {
                branch: "Instrumental and control Eng",
                sem: "4",
                sub: [
                    "Communication Skill-II",
                    "Principles of Digital Electronics ",
                    "Network Filters and Transmission Line  ",
                    "PROCESS INSTRUMENTATION  ",
                    "Energy Conservation",
                    "Electronic Instruments and Measurement",

                ],
            },
            {
                branch: "Instrumental and control Eng",
                sem: "5",
                sub: [
                    "Industrial Training",
                    "Industrial Management & Entrepreneurship Development ",
                    "Microprocessor& Peripheral Devices ",
                    "INDUSTRIAL CONTROL",
                    "SIGNAL TRANSMISSION RECORDING AND DISPLAY ",
                    "Programming in C  ",
                    "Minor Project Work  ",


                ],
            },
            {
                branch: "Instrumental and control Eng",
                sem: "6",
                sub: [
                    "PROCESS CONTROL",
                    "Microcontrollers and Embedded System ",
                    "MElective  ",
                    "BIO- MEDICAL INSTRUMENTATIONL",
                    "Project Work ",

                ],
            },
            //Electrical engineering
            {
                branch: "Electrical",
                sem: "1",
                sub: [
                    "Communication Skill-I",
                    "Applied mathematics-I",
                    "Applied physics-I",
                    "Applied chemistry",
                    "Workshop-I",
                    "Basics of Information Technology",
                    "Engineering Drawing-I"
                ],
            },
            {
                branch: "Electrical",
                sem: "2",
                sub: [
                    "Applied mathematics-II",
                    "Applied physics-II",
                    "Basic Electrical Engineering",
                    "Basics of Mechanical and Civil Engineering ",
                    "Analog Electronics",
                    "Workshop-II"
                ],
            },
            {
                branch: "Electrical",
                sem: "3",
                sub: [
                    "Applied mathematics-III",

                    "Electrical  Instrumentation and Measurement ",
                    "Electrical and Electronics Engineering Materials ",
                    "Digital electronics",
                    "Electrical Machine - I ",
                    "Environmental Studies",

                ],
            },
            {
                branch: "Electrical",
                sem: "4",
                sub: [
                    "Communication Skill-II",
                    "Industrial Electronics and Control ",
                    "Electrical Design, Drawing and Estimating-I ",
                    "Power Plant Engineering  ",
                    "Transmission and Distribution of Electrical Power ",
                    "Universal Human Values ",
                    "Energy Conservation",
                    "Industrial Training ",

                ],
            },
            {
                branch: "Electrical",
                sem: "5",
                sub: [
                    "Industrial Management and Entrepreneurship Development ",
                    "Switchgear and Protection ",
                    "PLC, Microcontroller and SCADA ",
                    "Electrical Machine -II  ",
                    "Elective",

                ],
            },
            {
                branch: "Electrical",
                sem: "6",
                sub: [
                    "Installation, Maintenance and Repair of Electrical Equipment",
                    "Electrical Design, Drawing and Estimating II",
                    "Utilization of Electrical Energy",
                    "Application of Computer Software in Electrical Engineering",

                    "Project Work ",


                ],
            },
        ]

    var user = arr.filter(function (el) {
        return el.branch === props.Branch && el.sem === props.semNumber;
    }
    );
    // console.log("d", user);

    return (
        <div>
            <div className="container d-flex justify-content-center">
                <button className="btn btn-primary mx-1 my-3" onClick={(e) => props.setDisplay('Home')}>Home</button>
                <button className="btn btn-primary mx-1 my-3" onClick={(e) => props.setDisplay('Branch')}>Change Branch</button>
                <button className="btn btn-primary mx-1 my-3" onClick={(e) => props.setDisplay('Semester')}>Change Semester</button>
            </div>

            <h3 className="text-center">Branch: {props.Branch}</h3>
            <h4 className="text-center mb-4">Semester: {props.semNumber}</h4>


            <div className='my-3'>
                <h5 className="text-center">Choose a Subject</h5>
                {user.map((person, index) => (
                    <div key={index}>
                        {person.sub.map((subject, index) => (
                            <div key={index}>
                                <div className="container">
                                    <div id="list-example" className="list-group">
                                        <div className="list-group-item list-group-item-action selectors-item mb-1"
                                            onClick={(e) => { props.setSubject(subject);props.setDisplay('DownloadPg') }}
                                        >{subject}</div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                ))}
            </div>

        </div>
    )
}

export default Subjects;